export default __webpack_public_path__ + "static/media/unito.5d5dfb0a.svg";